import { Capacitor } from '@capacitor/core';

/**
 * 보상형 광고 공급자 추상화. GameScene 풀충전 모달이 이 인터페이스만
 * 사용하므로 네이티브 SDK 발급 지연돼도 웹에서 즉시 보상으로 흐름 검증 가능.
 *
 * Phase α.4에서 AdMobRewardProvider가 추가되고, isNativeApp() 분기로
 * 자동 선택됨. RevenueCat 등 다른 보상 채널을 추가해도 동일 인터페이스.
 */
export type AdRewardOutcome = 'reward' | 'dismiss' | 'error';

export interface AdRewardProvider {
  /** 광고 표시. 사용자가 끝까지 시청 → 'reward', 중간 닫음 → 'dismiss',
   * SDK 실패 → 'error'. 단일 호출 시퀀스이므로 중복 호출 시 두 번째는
   * 'dismiss'를 즉시 반환해야 함. */
  showRewarded(): Promise<AdRewardOutcome>;
}

export class MockAdRewardProvider implements AdRewardProvider {
  async showRewarded(): Promise<AdRewardOutcome> {
    // 웹 폴백 — 1.5초 페이크 로딩 후 즉시 보상. 디자인 흐름 검증용.
    await new Promise((r) => setTimeout(r, 1500));
    return 'reward';
  }
}

let cached: Promise<AdRewardProvider> | null = null;

/**
 * 환경에 맞는 공급자 반환. Task 5에서 AdMobRewardProvider import를 동적으로
 * 추가해 native 분기 활성화. 첫 호출 시 캐시.
 */
export function getAdReward(): Promise<AdRewardProvider> {
  if (!cached) {
    cached = (async () => {
      if (Capacitor.isNativePlatform()) {
        // 동적 import — 웹 번들에는 admob 코드가 포함되지 않음.
        const { AdMobRewardProvider } = await import('./AdMobReward');
        return new AdMobRewardProvider();
      }
      return new MockAdRewardProvider();
    })().catch((err) => {
      cached = null;
      throw err;
    });
  }
  return cached;
}
